class AdToolWindowDelegate {

    constructor($scope, $el, $rootScope) {

        this.$scope = $scope;
        this.$el = $el;
        this.$rootScope = $rootScope;

        this.$scope.selected = false;

        this.handles = [
            { selector: ".toolwindow-handle.n", axis: "y" },
            { selector: ".toolwindow-handle.s", axis: "y" },
            { selector: ".toolwindow-handle.e", axis: "x" },
            { selector: ".toolwindow-handle.w", axis: "x" },
            { selector: ".toolwindow-handle.ne1", axis: undefined },
            { selector: ".toolwindow-handle.ne2", axis: undefined },
            { selector: ".toolwindow-handle.se1", axis: undefined },
            { selector: ".toolwindow-handle.se2", axis: undefined },
            { selector: ".toolwindow-handle.sw1", axis: undefined },
            { selector: ".toolwindow-handle.sw2", axis: undefined },
            { selector: ".toolwindow-handle.nw1", axis: undefined },
            { selector: ".toolwindow-handle.nw2", axis: undefined }
        ];

        this.handlers = {
            "n": this.handleN,
            "ne": this.handleNE,
            "e": this.handleE,
            "se": this.handleSE,
            "s": this.handleS,
            "sw": this.handleSW,
            "w": this.handleW,
            "nw": this.handleNW
        };

    }

    init() {
        this.setupResizeHandles();
        this.setupMoveHandle();
        this.setupSelect();
    }

    setupSelect() {

        this.$el.click(() => {
            if(!this.$scope.selected) {
                this.$rootScope.$broadcast("select-toolwindow", { id: this.$scope.$id, group: this.$scope.group });
            }
        });

        this.$el.on("select-toolwindow", (ev, args) => {
            if(!this.$scope.selected) {
                this.select();
                this.$scope.selected = true;
            }
        });
        
        this.$rootScope.$on("select-toolwindow", (ev, args) => {
            if(this.$scope.group === args.group) {
                if(this.$scope.$id === args.id) {
                    if(!this.$scope.selected) {
                        this.select();
                        this.$scope.selected = true;
                    }
                }
                else {
                    if(this.$scope.selected) {
                        this.deselect();
                    }
                    this.$scope.selected = false;
                }
            }
        });

    }

    setupMoveHandle() {

        $(".property-page-header", this.$el).draggable({
            appendTo: this.$el.parent(),
            helper: "clone",
            drag: (ev, ui) => {
                let thisOffset = this.$el.offset();
                let thisPos = this.$el.position();
                let top = (ui.offset.top - thisOffset.top + thisPos.top);
                let left = (ui.offset.left - thisOffset.left + thisPos.left);
                this.$el.css({
                    top: top,
                    left: left
                });
                $(".property-page-header", this.$el).css({top: 0, left: 0});
            }
        });


    }

    setupResizeHandles() {

        $(this.handles).each( (ix, h) => {
            $(h.selector, this.$el).draggable({
                axis: h.axis,
                helper: () => document.createElement("div"),
                start: (ev, ui) => {
                    this.startDimsWindow = {
                        top: this.$el.position().top,
                        left: this.$el.position().left,
                        width: this.$el.width(),
                        height: this.$el.height()
                    };
                    this.startDimsHandle = $(ev.target).offset();
                },
                drag: (ev, ui) => {
                    let $tgt = $(ev.target);
                    let dir = $tgt.attr("data-dir");
                    let offset = $tgt.offset();
                    var delta = {
                        left: ui.offset.left - this.startDimsHandle.left,
                        top: ui.offset.top - this.startDimsHandle.top
                    };
                    if(Math.abs(delta.top) < this.startDimsWindow.height && Math.abs(delta.left) < this.startDimsWindow.width) {                        
                        this.handlers[dir].call(this, delta);
                    }
                }
            });
        });

    }

    select() {
        this.$el.css("z-index", 1000);
        this.$el.trigger("selected", true);
    }

    deselect() {
        this.$el.css("z-index", 999);
        this.$el.trigger("selected", false);
    }

    close() {
        this.$el.trigger("selected", false);
        this.$scope.closeFn();
    }

    handleN(delta, dims) {
        this.handleDirection({
            top: this.startDimsWindow.top + delta.top,
            height: this.startDimsWindow.height - delta.top
        });
    }

    handleNE(delta, dims) {
        this.handleDirection({
            top: this.startDimsWindow.top + delta.top,
            height: this.startDimsWindow.height - delta.top,
            width: this.startDimsWindow.width + delta.left
        });
    }

    handleE(delta, dims) {        
        this.handleDirection({
            width: this.startDimsWindow.width + delta.left
        });
    }

    handleSE(delta, dims) {
        this.handleDirection({
            width: this.startDimsWindow.width + delta.left,
            height: this.startDimsWindow.height + delta.top,
        });
    }

    handleS(delta, dims) {
        this.handleDirection({
            height: this.startDimsWindow.height + delta.top
        });
    }

    handleSW(delta, dims) {
        this.handleDirection({
            left: this.startDimsWindow.left + delta.left,
            width: this.startDimsWindow.width - delta.left,
            height: this.startDimsWindow.height + delta.top           
        });
    }

    handleW(delta, dims) {
        this.handleDirection({
            left: this.startDimsWindow.left + delta.left,
            width: this.startDimsWindow.width - delta.left
        });
    }

    handleNW(delta, dims) {
        this.handleDirection({
            top: this.startDimsWindow.top + delta.top,
            left: this.startDimsWindow.left + delta.left,
            width: this.startDimsWindow.width - delta.left,
            height: this.startDimsWindow.height - delta.top           
        });
    }

    handleDirection(elOpts) {
        this.$el.css(elOpts);
    }

}

class AdToolWindow {


    constructor($rootScope) {

        this.$rootScope = $rootScope;

        return {
            restrict: 'E',
            transclude: "true",
            templateUrl: "builder/ad-tool-window.html",
            scope: {
                closeFn: "&",
                title: "@",
                resizing: "@",
                group: "@"
            },
            link: ($scope, $el, $attr) => {

                let delegate = new AdToolWindowDelegate($scope, $el, $rootScope);
                delegate.init();

                $scope.close = () => delegate.close.call(delegate);

                $rootScope.$broadcast("select-toolwindow", { id: $scope.$id, group: $scope.group });

                $el.on("close", (ev, group) => {
                    if(group == $scope.group) {
                        delegate.close.call(delegate);
                    }
                });
                
            }
        };
    }

}

angular.module('cpm')
    .directive('adToolWindow', ["$rootScope", ($rootScope) => {
        'use strict';
        return new AdToolWindow($rootScope); // this is a singleton!
    }]);
